import React from "react";

/**
 * Arrow Right Icon Component
 * Right arrow SVG icon for navigation and "View All" buttons
 */
const ArrowRightIcon = ({ className = "w-4 h-4", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className={`${className} flex-shrink-0`}
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
      />
    </svg>
  );
};

export default ArrowRightIcon;
